export default __webpack_public_path__ + "static/media/face_statistics_number.b71fa6b2.svg";